import Vue from 'vue';
import Router from 'vue-router';
import NotFound from '@/pages/NotFound.vue';
import OptinConfirmed from '@/pages/OptinConfirmed.vue';
import GiftCardLanding from '@/pages/GiftCardLanding.vue';
import Unsubscribe from '@/pages/Unsubscribe.vue';
import PreviewLink from '@/pages/PreviewLink.vue';
import Share from '@/pages/Share.vue';
import FooterAd from '@/pages/FooterAd.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/preview',
      name: 'preview',
      component: PreviewLink,
      children: [
        {
          path: '/preview/:hash',
          name: 'previewHash',
        },
        {
          path: '/preview/link/:hash',
          name: 'previewLinkHash',
        },
      ],
    },
    {
      path: '/share',
      name: 'share',
      component: Share,
    },
    {
      path: '/unsubscribe',
      name: 'unsubscribe',
      component: Unsubscribe,
    },
    {
      path: '/optin/confirmed',
      name: 'optin-confirmed',
      component: OptinConfirmed,
    },
    {
      path: '/giftcard/:encoded',
      name: 'giftcard',
      component: GiftCardLanding,
    },
    {
      path: '/footerad',
      name: 'footerad',
      component: FooterAd,
    },
    {
      path: '/404',
      component: NotFound,
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});
